import { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import './TutorialsCardVideo.css';
import 'react-modal-video/css/modal-video.min.css';

const TutorialsCardVideo = ({ url }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const [isOpen, setOpen] = useState(false);
  const videoId = new URL(url).searchParams.get('v');

  return (
    <>
      <button
        className="tutorials-thumb"
        onClick={() => setOpen(true)}
        aria-label={tempedgeTranslator('com.tempedge.msg.title.watch_video')}
      >
        <img
          src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
          alt=""
          className="tutorials-thumb-img"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
          }}
        />
        <span className="tutorials-thumb-overlay">
          <span className="tutorials-play-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          </span>
        </span>
      </button>
      <ModalVideo
        youtube={{ mute: 0, autoplay: 0 }}
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId={videoId}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default TutorialsCardVideo;
